import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useEffect, useState } from 'react';
import FieldTitle from '../Forms/FieldTitle';
import { Form, Field } from 'react-final-form';
import BtxSwitch from '../Forms/BtxSwitch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { actions } from '../../context';
import { useDispatch } from 'react-redux';

const AddRelationModal = ({
    isOpen = false,
    practice = {},
    refresh,
    relations = [],
    toggle,
    relation,
}) => {
    const dispatch = useDispatch();
    const [convertAttachments, setConvertAttachments] = useState(false);

    const toggleConvertAttachments = () =>
        setConvertAttachments(!convertAttachments);

    const [isFetchingData, setIsFetchingData] = useState(true);
    const [partners, setPartners] = useState([]);

    useEffect(() => {
        if(isOpen) {
            // refreshPartners
            dispatch(actions.offerings.getAllOfferings())
                .then((res) => setPartners(res.data.data))
                .finally(() => setIsFetchingData(false));
        }
    }, [dispatch, isOpen]);

    useEffect(() => {
        if (isOpen) {
            setConvertAttachments(false);
            if (relation && relation.convertAttachments)
                setConvertAttachments(true);
        }
    }, [isOpen, relation]);

    const submit = async (vals) => {
        let request;
        if (relation) {
            request = dispatch(
                actions.relations.updateRelation(
                    practice.id,
                    vals.partnerOfferingId,
                    vals?.customPartnerId,
                    convertAttachments
                )
            );
        } 
        else 
        {
            
            request = dispatch(actions.relations.getPracticeRelationbyOfferingId(
                vals.partnerOfferingId, 
                vals?.customPartnerId,
                convertAttachments))
            .then((res) => {
                dispatch(
                    actions.practice.addOfferingStep2(res.data.data)
                );
            })
        }
        request.then(() => {
            refresh();
            toggle();
        });
    };

    return (
        <Modal
            centered
            isOpen={isOpen}
            className="text-light"
            toggle={toggle}
            style={{ minWidth: '35vw' }}>
            {isFetchingData && (<div className="loading-spinner spin-animate mx-auto my-4"></div>)}
            {!isFetchingData && (
            <Form
                initialValues={{ ...(relation || {}) }}
                onSubmit={submit}
                render={({
                    handleSubmit,
                    values,
                    form,
                    submitting,
                    pristine,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <ModalHeader>
                            {relation ? 'Edit' : 'Add'} Offering
                        </ModalHeader>
                        <ModalBody>
                            <FieldTitle title="Partner" />
                            <Field
                                name="partnerId"
                                component="select"
                                required
                                disabled={relation}
                                className="w-50 p-2 rounded mb-4"
                                defaultValue={''}>
                                <option value="" disabled>
                                    Select Partner
                                </option>
                                {partners.map((p, x) => (
                                    <option key={x} value={p.id}>
                                        {p.name}
                                    </option>
                                ))}
                            </Field>
                            {values.partnerId && (
                                <>
                                    <FieldTitle title="Offering" />
                                    <Field
                                        name="partnerOfferingId"
                                        component="select"
                                        required
                                        disabled={relation}
                                        className="w-50 p-2 rounded mb-4"
                                        defaultValue={''}>
                                        <option value="" disabled>
                                            Select Offering
                                        </option>
                                        {partners
                                            .filter(
                                                (p) =>
                                                    p.id === values?.partnerId
                                            )[0]
                                            ?.offerings.filter(
                                                (o) =>
                                                    relation ||
                                                    !relations
                                                        .map(
                                                            (r) =>
                                                                r.partnerOfferingId
                                                        )
                                                        .includes(o.id)
                                            )
                                            .map((o, x) => (
                                                <option key={x} value={o.id}>
                                                    {o.name}
                                                </option>
                                            ))}
                                    </Field>
                                </>
                            )}
                            <FieldTitle title="Partner Custom Identifier" />
                            <Field
                                className="w-75 p-2 rounded border mb-4"
                                component="input"
                                name="customPartnerId"
                                placeholder="Custom Id"
                                type="search"
                            />
                            {values?.partnerOfferingId &&
                                (
                                    partners
                                        .filter(
                                            (p) => p.id === values?.partnerId
                                        )[0]
                                        .offerings.filter(
                                            (o) =>
                                                o.id ===
                                                values.partnerOfferingId
                                        )[0] || {}
                                )?.isDaylightOffering && (
                                    <div>
                                        <FontAwesomeIcon icon={faCheck} />
                                        &emsp;Daylight Connected
                                    </div>
                                )}
                            {values?.partnerOfferingId &&
                                (
                                    partners
                                        .filter(
                                            (p) => p.id === values?.partnerId
                                        )[0]
                                        .offerings.filter(
                                            (o) =>
                                                o.id ===
                                                values.partnerOfferingId
                                        )[0] || {}
                                )?.isConversionOffering && (
                                    <div>
                                        <FontAwesomeIcon icon={faCheck} />
                                        &emsp;Conversion Offering
                                    </div>
                                )}
                            {values?.partnerOfferingId &&
                                (
                                    partners
                                        .filter(
                                            (p) => p.id === values?.partnerId
                                        )[0]
                                        .offerings.filter(
                                            (o) =>
                                                o.id ===
                                                values.partnerOfferingId
                                        )[0] || {}
                                )?.isConversionOffering && (
                                    <div className="mt-4">
                                        <FieldTitle title="Convert Practice Attachments?" />
                                        <BtxSwitch
                                            value={convertAttachments}
                                            onChange={toggleConvertAttachments}
                                        />
                                    </div>
                                )}
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="danger"
                                className="border"
                                onClick={toggle}>
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                color="success"
                                className="border">
                                Submit
                            </Button>
                        </ModalFooter>
                    </form>
                )}
            />    
            )}
        </Modal>
    );
};

export default AddRelationModal;
